import { lazy } from 'react'

export const EventFeedback = lazy(() => import('./v1/EventFeedback'))
export const EventFeedbackV2 = lazy(() => import('./v2/EventFeedbackV2'))
export const EventFeedbackV3 = lazy(() => import('./v3/EventFeedbackV3'))
